import { recipes, categories } from './recipeData';

function getViewCounts() {
  try {
    return JSON.parse(localStorage.getItem('recipeViews') || '{}');
  } catch {
    return {};
  }
}

function getTopRecipes(count) {
  const views = getViewCounts();
  return [...recipes]
    .sort((a, b) => (views[b.id] || 0) - (views[a.id] || 0))
    .slice(0, count);
}

function RecipeBrowser({ onSelect }) {
  const topRecipes = getTopRecipes(3);
  const recipesByCategory = {};
  categories.forEach(cat => {
    recipesByCategory[cat] = recipes.filter(r => r.category === cat);
  });

  return (
    <div className="RecipeBrowser">
      <div className="RecipeBrowser-top">
        {topRecipes.map(recipe => (
          <button
            key={recipe.id}
            className={`RecipeBrowser-top-btn${recipe.images?.[0] ? ' RecipeBrowser-top-btn--image' : ''}`}
            onClick={() => onSelect(recipe.id)}
          >
            {recipe.images?.[0] ? (
              <>
                <img className="RecipeBrowser-top-img" src={recipe.images[0]} alt="" />
                <span className="RecipeBrowser-top-label">{recipe.name}</span>
              </>
            ) : (
              recipe.name
            )}
          </button>
        ))}
      </div>

      {categories.map(cat => {
        const catRecipes = recipesByCategory[cat];
        return (
          <div key={cat} className="RecipeBrowser-category">
            <h2 className="RecipeBrowser-category-title">{cat}</h2>
            {catRecipes.length > 0 ? (
              <div className="RecipeBrowser-grid">
                {catRecipes.map(recipe => (
                  <button
                    key={recipe.id}
                    className={`RecipeBrowser-card${recipe.images?.[0] ? ' RecipeBrowser-card--image' : ''}`}
                    onClick={() => onSelect(recipe.id)}
                  >
                    {recipe.images?.[0] ? (
                      <>
                        <img className="RecipeBrowser-card-img" src={recipe.images[0]} alt={recipe.name} />
                        <span className="RecipeBrowser-card-body">
                          <span className="RecipeBrowser-card-name">{recipe.name}</span>
                          <span className="RecipeBrowser-card-meta">Yield: {recipe.baseYield}</span>
                        </span>
                      </>
                    ) : (
                      <>
                        <span className="RecipeBrowser-card-name">{recipe.name}</span>
                        <span className="RecipeBrowser-card-meta">Yield: {recipe.baseYield}</span>
                      </>
                    )}
                  </button>
                ))}
              </div>
            ) : (
              <p className="RecipeBrowser-empty">Coming soon</p>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default RecipeBrowser;
